/* Blunt landing page: minimal JS (trust bar rotation, video wall, before/after slider, FAQ accordion). No libraries. */
(function () {
  'use strict';
  if (window.__bluntLanding) return;
  window.__bluntLanding = true;

  // Test helpers: add ?popup=1 to always show the popup, or ?popup=debug to also print a status box on screen
  var DEBUG = /[?&]popup=debug/.test(location.search);
  var FORCE = /[?&]popup=(1|debug)/.test(location.search);
  var dbgLines = [], dbgEl = null;
  function dbg(msg) {
    if (!DEBUG) return;
    dbgLines.push(msg);
    if (!dbgEl && document.body) {
      dbgEl = document.createElement('pre');
      dbgEl.style.cssText = 'position:fixed;left:6px;right:6px;top:6px;z-index:2147483647;margin:0;padding:8px;background:#000;color:#0f0;font:11px/1.35 monospace;white-space:pre-wrap;max-height:45vh;overflow:auto;border-radius:8px';
      document.body.appendChild(dbgEl);
    }
    if (dbgEl) dbgEl.textContent = dbgLines.join('\n');
  }
  if (DEBUG) {
    window.addEventListener('error', function (e) { dbg('ERROR: ' + e.message + ' @' + String(e.filename || '').split('/').pop() + ':' + e.lineno); });
    dbg('script started | ' + navigator.userAgent.replace(/\(.*?\)/, '').slice(0, 70));
  }

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function trustBar(root) {
    var items = root.querySelectorAll('.blunt-trust__item');
    if (items.length < 2) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var i = 0, timer = null;
    function show(n) {
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === n); });
    }
    function start() {
      stop();
      if (!mq.matches) return;
      root.classList.add('is-js');
      show(i);
      if (!reduced) timer = setInterval(function () { i = (i + 1) % items.length; show(i); }, 3200);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    start();
    (mq.addEventListener ? mq.addEventListener('change', start) : mq.addListener(start));
  }

  function videoWall(root) {
    var frames = root.querySelectorAll('.blunt-videos__frame');
    if (!('IntersectionObserver' in window)) return;
    function load(v) {
      if (v.dataset.loaded) return;
      v.dataset.loaded = '1';
      var srcs = v.querySelectorAll('source[data-src]');
      srcs.forEach(function (s) { s.src = s.dataset.src; });
      v.load();
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (!v) return;
        if (e.isIntersecting) {
          load(v);
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.6 });
    var pre = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var v = e.target.querySelector('video'); if (v) load(v); pre.unobserve(e.target); }
      });
    }, { rootMargin: '0px 300px' });
    frames.forEach(function (f) {
      io.observe(f); pre.observe(f);
      var btn = f.querySelector('.blunt-videos__sound');
      var v = f.querySelector('video');
      if (!btn || !v) return;
      function toggle() {
        var unmute = v.muted;
        frames.forEach(function (o) {
          var ov = o.querySelector('video');
          if (ov) { ov.muted = true; o.classList.remove('is-unmuted'); }
        });
        if (unmute) { v.muted = false; f.classList.add('is-unmuted'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      btn.addEventListener('click', function (ev) { ev.stopPropagation(); toggle(); });
      v.addEventListener('click', toggle);
    });
  }

  function beforeAfter(root) {
    var handle = root.querySelector('.blunt-ba__handle');
    var dragging = false;
    function set(x) {
      var r = root.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
      root.style.setProperty('--pos', pct + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(pct));
    }
    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
      set(e.clientX);
    });
    root.addEventListener('pointermove', function (e) { if (dragging) set(e.clientX); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      root.addEventListener(t, function () { dragging = false; });
    });
    if (handle) handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(getComputedStyle(root).getPropertyValue('--pos')) || 50;
      if (e.key === 'ArrowLeft') cur -= 5; else if (e.key === 'ArrowRight') cur += 5; else return;
      cur = Math.max(0, Math.min(100, cur));
      root.style.setProperty('--pos', cur + '%');
      handle.setAttribute('aria-valuenow', Math.round(cur));
      e.preventDefault();
    });
  }

  function faq(root) {
    var all = root.querySelectorAll('details');
    all.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        all.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function buybox(root) {
    var atc = root.querySelector('[data-blunt-atc]');
    var priceEl = root.querySelector('[data-blunt-atc-price]');
    var radios = root.querySelectorAll('.blunt-opt input');
    var sel = root.querySelector('[data-blunt-variant]');
    var ups = root.querySelectorAll('[data-upsell]');
    var pid = root.querySelector('[data-blunt-pid]'), pq = root.querySelector('[data-blunt-pqty]');
    var express = root.querySelector('[data-blunt-express]'), exNote = root.querySelector('[data-blunt-express-note]');
    function setExpress(ok, n) {
      if (!express) return;
      var form = express.querySelector('form');
      if (form) form.hidden = !ok;
      if (exNote) exNote.hidden = ok || !n;
    }
    function sync() {
      var extra = '', n = 0;
      ups.forEach(function (u) {
        u.closest('.blunt-up').classList.toggle('is-selected', u.checked);
        if (u.checked) { extra += ',' + u.dataset.upsell + ':1'; n++; }
      });
      radios.forEach(function (r) {
        r.closest('.blunt-opt').classList.toggle('is-selected', r.checked);
        if (r.checked) {
          if (pid && r.dataset.variant) pid.value = r.dataset.variant;
          if (pq) pq.value = r.dataset.qty || 1;
          setExpress(r.dataset.express !== 'false' && n === 0, n);
        }
        if (r.checked && atc) {
          atc.setAttribute('href', r.dataset.href + extra);
          if (priceEl) priceEl.textContent = (r.dataset.price || '') + (n ? ' + ' + n + ' add-on' + (n > 1 ? 's' : '') : '');
        }
      });
    }
    function syncSelect() {
      if (!sel || !atc) return;
      var o = sel.options[sel.selectedIndex];
      var extra = '', n = 0;
      ups.forEach(function (u) {
        u.closest('.blunt-up').classList.toggle('is-selected', u.checked);
        if (u.checked) { extra += ',' + u.dataset.upsell + ':1'; n++; }
      });
      atc.setAttribute('href', o.dataset.href + extra);
      if (pid) pid.value = o.value;
      if (pq) pq.value = 1;
      setExpress(n === 0, n);
      var dp = root.querySelector('[data-dyn-price]'); if (dp) dp.textContent = o.dataset.price;
      var dc = root.querySelector('[data-dyn-compare]'); if (dc) dc.remove();
      if (priceEl) priceEl.textContent = n ? ' + ' + n + ' add-on' + (n > 1 ? 's' : '') : '';
    }
    if (sel) { sel.addEventListener('change', syncSelect); syncSelect(); }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    ups.forEach(function (u) { u.addEventListener('change', sel ? syncSelect : sync); });
    if (radios.length) {
      var any = false;
      radios.forEach(function (r) { if (r.checked) any = true; });
      if (!any) radios[0].checked = true;
      sync();
    }
    var thumbs = root.querySelectorAll('[data-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === t.dataset.thumb); });
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });
  }

  function sticky(bar) {
    var hero = document.getElementById('BluntHero');
    var buy = document.getElementById('buy');
    if (!hero || !('IntersectionObserver' in window)) return;
    var heroGone = false, buyVisible = false;
    function update() {
      var on = heroGone && !buyVisible;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = bar.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (e) {
      var en = e[0];
      heroGone = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      update();
    }).observe(hero);
    if (buy) new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; update(); }).observe(buy);
  }

  // Cart permalinks (/cart/VARIANT:QTY,...) jump straight to checkout. Add via the cart API and open the cart page instead.
  // The href stays as a no-JS fallback.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.blunt-section a[href^="/cart/"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var path = a.getAttribute('href').split('?')[0].replace('/cart/', '');
    var items = path.split(',').map(function (part) {
      var bits = part.split(':');
      return { id: parseInt(bits[0], 10), quantity: parseInt(bits[1], 10) || 1 };
    }).filter(function (i) { return i.id; });
    if (!items.length) return;
    e.preventDefault();
    if (a.dataset.busy) return;
    a.dataset.busy = '1';
    a.style.opacity = '.7';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      // Open the pop-out cart (Upcart) so the next tap is Checkout. Fall back to the cart page only if it isn't there.
      if (typeof window.upcartOpenCart === 'function') {
        var refreshed = typeof window.upcartRefreshCart === 'function' ? window.upcartRefreshCart() : null;
        return Promise.resolve(refreshed).then(function () {
          window.upcartOpenCart();
          a.dataset.busy = ''; a.style.opacity = '';
        });
      }
      window.location.href = '/cart';
    }).catch(function () {
      window.location.href = a.getAttribute('href');
    });
  });

  function scratchPopup(root) {
    var KEY = 'blunt_scratch_seen';
    var freq = root.dataset.frequency || 'session';
    var days = parseFloat(root.dataset.days) || 7;
    var inEditor = root.dataset.design === 'true';
    dbg('popup found | game=' + root.dataset.game + ' freq=' + freq + ' delay=' + root.dataset.delay + ' editor=' + inEditor + ' force=' + FORCE);
    if (inEditor && root.dataset.editor !== 'true') { dbg('stopped: theme editor preview'); return; }
    try {
      if (!FORCE && !inEditor && freq === 'session' && sessionStorage.getItem(KEY)) { dbg('stopped: already shown this visit (session flag set)'); return; }
      var seen = localStorage.getItem(KEY);
      if (!FORCE && !inEditor && freq === 'days' && seen && Date.now() - parseInt(seen, 10) < days * 864e5) { dbg('stopped: shown within the last ' + days + ' days'); return; }
    } catch (e) { dbg('storage blocked (' + e.message + ') - continuing'); }
    var canvas = root.querySelector('[data-scratch-canvas]');
    var ctx = canvas ? canvas.getContext('2d') : null;
    var won = false, drawing = false, moves = 0, lastFocus = null;

    function paintFoil() {
      var r = canvas.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, r.width, r.height);
      g.addColorStop(0, '#c9b38a'); g.addColorStop(.5, '#efe0b8'); g.addColorStop(1, '#b89c6a');
      ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
      ctx.fillStyle = 'rgba(255,255,255,.35)';
      for (var i = 0; i < 40; i++) ctx.fillRect(Math.random() * r.width, Math.random() * r.height, 2, 2);
      ctx.fillStyle = '#6b5636'; ctx.font = '800 18px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(canvas.dataset.label || 'SCRATCH HERE', r.width / 2, r.height / 2);
    }
    var lx = null, ly = null;
    function scratchAt(x, y) {
      var r = canvas.getBoundingClientRect(), cx = x - r.left, cy = y - r.top;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 48; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.beginPath();
      if (lx === null) { ctx.arc(cx, cy, 24, 0, Math.PI * 2); ctx.fill(); }
      else { ctx.moveTo(lx, ly); ctx.lineTo(cx, cy); ctx.stroke(); }
      lx = cx; ly = cy;
    }
    function coverage() {
      var w = canvas.width, h = canvas.height, d = ctx.getImageData(0, 0, w, h).data, clear = 0, total = 0;
      for (var i = 3; i < d.length; i += 64) { total++; if (d[i] === 0) clear++; }
      return clear / total;
    }
    function reveal() {
      if (won) return; won = true;
      if (canvas) canvas.classList.add('is-done');
      root.classList.add('is-won');
      var code = root.dataset.code;
      if (code) { try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }
    }
    function open() {
      if (root.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      root.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      dbg('OPENED popup (display=' + getComputedStyle(root).display + ')');
      if (canvas) paintFoil();
      try { localStorage.setItem(KEY, String(Date.now())); sessionStorage.setItem(KEY, '1'); } catch (e) {}
      var c = root.querySelector('[data-scratch-close]'); if (c) c.focus();
    }
    function close() {
      root.classList.remove('is-open'); document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (canvas) canvas.addEventListener('pointerdown', function (e) { drawing = true; lx = null; try { canvas.setPointerCapture(e.pointerId); } catch (x) {} scratchAt(e.clientX, e.clientY); });
    if (canvas) canvas.addEventListener('pointermove', function (e) {
      if (!drawing || won) return;
      scratchAt(e.clientX, e.clientY);
      if (++moves % 6 === 0 && coverage() > 0.45) reveal();
    });
    if (canvas) ['pointerup', 'pointercancel'].forEach(function (t) { canvas.addEventListener(t, function () { drawing = false; lx = null; if (!won && coverage() > 0.45) reveal(); }); });
    root.querySelectorAll('[data-scratch-close]').forEach(function (b) { b.addEventListener('click', close); });
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    window.addEventListener('resize', function () { if (canvas && root.classList.contains('is-open') && !won) paintFoil(); });
    // Slice the tomato: drag the knife across (or tap the fallback link) to split the tomato and reveal the prizes
    var slice = root.querySelector('[data-slice]');
    if (slice) {
      var knife = slice.querySelector('[data-slice-knife]');
      var tapBtn = slice.querySelector('[data-slice-tap]');
      var dragging = false, sliced = false, moved = false, startX = 0, startLeft = 0, left = 0;
      var maxLeft = function () { return slice.clientWidth - knife.offsetWidth - 8; };
      var setLeft = function (v) { left = Math.max(0, Math.min(maxLeft(), v)); knife.style.transform = 'translateX(' + left + 'px)'; };
      var doSlice = function () {
        if (sliced) return; sliced = true; dragging = false;
        slice.classList.add('is-sliced'); knife.classList.remove('is-drag'); knife.classList.add('is-done');
        knife.style.transform = 'translateX(' + (slice.clientWidth + 30) + 'px)';
        reveal();
      };
      knife.addEventListener('pointerdown', function (e) {
        if (sliced) return;
        dragging = true; moved = false; startX = e.clientX; startLeft = left;
        try { knife.setPointerCapture(e.pointerId); } catch (x) {}
        knife.classList.add('is-drag');
      });
      knife.addEventListener('pointermove', function (e) {
        if (!dragging || sliced) return;
        if (Math.abs(e.clientX - startX) > 3) moved = true;
        setLeft(startLeft + e.clientX - startX);
        if (left >= maxLeft() * 0.62) doSlice();
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        knife.addEventListener(ev, function () {
          if (sliced) return;
          dragging = false; knife.classList.remove('is-drag'); setLeft(0);
        });
      });
      knife.addEventListener('click', function (e) { if (e.detail === 0) doSlice(); }); // keyboard
      if (tapBtn) tapBtn.addEventListener('click', doSlice);
    }

    // Optional email signup (Shopify customer form, sent in the background)
    var emailBox = root.querySelector('[data-scratch-email]');
    if (emailBox) {
      var form = emailBox.querySelector('form');
      var ok = emailBox.querySelector('[data-scratch-thanks]'), bad = emailBox.querySelector('[data-scratch-err]');
      try { if (localStorage.getItem('blunt_email_done')) emailBox.hidden = true; } catch (e) {}
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        if (btn) btn.disabled = true;
        if (bad) bad.hidden = true;
        fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('signup');
            form.hidden = true; if (ok) ok.hidden = false;
            try { localStorage.setItem('blunt_email_done', '1'); } catch (x) {}
          })
          .catch(function () { if (bad) bad.hidden = false; if (btn) btn.disabled = false; });
      });
    }
    root.__bluntOpen = open;
    dbg('timer set: opening in ' + (FORCE ? 1 : (parseFloat(root.dataset.delay) || 5)) + 's');
    setTimeout(open, (FORCE ? 1 : (parseFloat(root.dataset.delay) || 5)) * 1000);
  }

  function reviewsCarousel(root) {
    var track = root.querySelector('.blunt-reviews__track');
    var prev = root.querySelector('[data-rev-prev]'), next = root.querySelector('[data-rev-next]');
    if (!track) return;
    function step() { var c = track.querySelector('.blunt-review'); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function upd() {
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  // Loop videos (GIF-style): load when near the screen, play only while visible, pause off-screen to save battery and data
  function loopVideo(frame) {
    var v = frame.querySelector('video');
    if (!v || !('IntersectionObserver' in window)) return;
    var loaded = false;
    function load() {
      if (loaded) return; loaded = true;
      v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
      v.load();
    }
    new IntersectionObserver(function (e) { if (e[0].isIntersecting) load(); }, { rootMargin: '300px 0px' }).observe(frame);
    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    }, { threshold: 0.4 }).observe(frame);
  }

  // As-featured-in strip: the page ships a small set of logos; top it up on wide screens so the loop never shows a gap
  function logosFill(track) {
    var groups = track.querySelectorAll('.blunt-logos__group');
    if (groups.length < 2) return;
    var g1 = groups[0], g2 = groups[1];
    var base = g1.__bluntBase || (g1.__bluntBase = Array.prototype.slice.call(g1.children));
    function fill() {
      var need = window.innerWidth + 160, guard = 0;
      while (g1.getBoundingClientRect().width < need && guard++ < 12) {
        base.forEach(function (it) {
          var c = it.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-block-id');
          var im = c.querySelector('img'); if (im) im.setAttribute('alt', '');
          g1.appendChild(c);
        });
      }
      g2.innerHTML = g1.innerHTML;
    }
    fill();
    var timer = null;
    window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(fill, 250); });
  }

  function run(sel, fn) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.__bluntInit) return;
      el.__bluntInit = true;
      try { fn(el); } catch (err) { dbg('init failed for ' + sel + ': ' + err.message); if (window.console) console.error(err); }
    });
  }

  /* free shipping countdown: either counts down to a set end time, or repeats every N hours (same clock for every visitor) */
  function shipCountdown(el) {
    var raw = (el.getAttribute('data-end') || '').trim();
    var cycleH = parseFloat(el.getAttribute('data-cycle')) || 0;
    var out = el.querySelector('[data-blunt-ship-time]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function melbOffsetMin(ts) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Australia/Melbourne', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date(ts));
        var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
        return (Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour, +o.minute, +o.second) - ts) / 60000;
      } catch (e) { return 600; }
    }
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/);
    var end = null;
    if (m) {
      var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0);
      end = wall - melbOffsetMin(wall - 600 * 60000) * 60000;
    }
    if (!end && cycleH <= 0) return;
    var anchor = Date.UTC(2026, 0, 1, 0, 0, 0) - 11 * 3600000; /* 1 Jan 2026, midnight Melbourne */
    var timer;
    function leftSeconds() {
      if (end) return Math.floor((end - Date.now()) / 1000);
      var cyc = cycleH * 3600000;
      var into = (Date.now() - anchor) % cyc;
      return Math.ceil((cyc - into) / 1000);
    }
    function tick() {
      var left = leftSeconds();
      if (left <= 0) { el.hidden = true; if (timer) clearInterval(timer); return; }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), mi = Math.floor(left % 3600 / 60), s = left % 60;
      out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(s);
      el.hidden = false;
    }
    tick();
    if (!el.hidden) timer = setInterval(tick, 1000);
  }

  /* little button that scrolls to the reviews further down the page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-blunt-scrollto]');
    if (!a) return;
    var t = null, sels = ['#judgeme_product_reviews', '.jdgm-review-widget', '.jdgm-rev-widg', '[id*="judge_me_reviews"]', '[id$="__reviews"]'];
    for (var i = 0; i < sels.length && !t; i++) t = document.querySelector(sels[i]);
    if (!t) return;
    e.preventDefault();
    var top = t.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  function init() {
    if (DEBUG && !document.querySelector('[data-blunt-scratch]')) dbg('NO popup element on this page (is this the new theme?)');
    run('[data-blunt-trust]', trustBar);
    run('[data-blunt-videos]', videoWall);
    run('[data-blunt-ba]', beforeAfter);
    run('[data-blunt-faq]', faq);
    run('[data-blunt-buybox]', buybox);
    run('[data-blunt-sticky]', sticky);
    run('[data-blunt-scratch]', scratchPopup);
    run('[data-blunt-reviews]', reviewsCarousel);
    run('[data-blunt-loop]', loopVideo);
    run('[data-blunt-logos]', logosFill);
    run('[data-blunt-ship]', shipCountdown);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
